import { VerificationTaskStatusEnum } from "./enums/VerificationTaskStatusEnum"

export class AvailableActions {
  actions: Action[]
  messages: MessageAction[]
}

export class Action {
  currentStatus: string
  nextStatus: VerificationTaskStatusEnum
  class: any
  title: string
  actionId: number
  apiName: string
}
export class MessageAction {
  message: string
  image: string
}
